import * as Sentry from "@sentry/nextjs";
import validator from "validator";

const SentryInitializer = (props: { user: any }) => {
  // Do not run if we don't have the APP ID or no user yet
  if (!props.user?.id) return null;

  const email = props.user?.email ?? "";

  Sentry.setUser({
    id: props.user?.id,
    username: props.user?.email,
    fullName: `${props.user?.first_name ?? ""} ${props.user?.last_name ?? ""}`,
    email: validator.isEmail(email) ? email : "",
  });

  return null;
};

export default SentryInitializer;
